/**
 * RLQ — Retail Lobby Queue module entry.
 *
 * Loads both stylesheets — `rlq.css` keeps the ClaimAndStart splash + the
 * legacy single-row layout alive (still used by some deep-linked surfaces),
 * `lobby.css` carries the modernized 2026-04-23 card layout for the four
 * primary surfaces (Queue / Entry × 3 / Management).
 */
import './rlq.css';
import './lobby.css';
import { RlqRoutes } from './routes';

export default function RLQ(): JSX.Element {
  return <RlqRoutes />;
}
